module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/5@2x_71b27f11113030cb15bc9ea63709082e.png";